<template>
    <div>
         <nav class="navbar navbar-expand-lg navbar-absolute fixed-top  navbar-transparent ">
        <div class="container-fluid">
          <div class="navbar-wrapper">
            <div class="navbar-toggle">
              <button type="button" class="navbar-toggler">
                <span class="navbar-toggler-bar bar1"></span>
                <span class="navbar-toggler-bar bar2"></span>
                <span class="navbar-toggler-bar bar3"></span>
              </button>
            </div>
            <img src="/assets/img/navlogo.png" alt="" srcset="" class="img-fluid navlogo">
          </div>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-bar navbar-kebab"></span>
            <span class="navbar-toggler-bar navbar-kebab"></span>
            <span class="navbar-toggler-bar navbar-kebab"></span>
          </button>
          <div class="collapse navbar-collapse justify-content-end" id="navigation">
            <form>
              <div class="input-group no-border">
                 <p class="text-dark">{{getUserMail}} </p>  
              </div>
            </form>
            <ul class="navbar-nav">
              <li class="nav-item btn-rotate dropdown">
                <a class="nav-link dropdown-toggle" href="http://example.com" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="nc-icon nc-button-power"></i>
                  <p>
                    <span class="d-lg-none d-md-block">ÇIKIŞ YAP</span>
                  </p>
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
                  <a @click="logout" class="dropdown-item" href="#">ÇIKIŞ YAP</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
</template>

<script>
import { mapGetters} from "vuex";
export default {
    computed : {
      ...mapGetters(["getUserMail",])
    },
     data: function () {
      return {
     
    }
  },
  methods : {
    logout(){
      this.$store.dispatch("logout")
      this.$router.replace("/")
    }
  }
}
</script>

<style >
.navlogo{
  width: 250px;
}

</style>


// WEBPACK FOOTER //
// src/components/shared/Navbar.vue